export const files = new Map([[".vscode/extensions.json", {
  "type": "base64",
  "body": "ewogICJyZWNvbW1lbmRhdGlvbnMiOiBbIlZ1ZS52b2xhciIsICJWdWUudnNjb2RlLXR5cGVzY3JpcHQtdnVlLXBsdWdpbiJdCn0K"
}], ["README.md.hbs", {
  type: "raw",
  body: `# {{project}}

{{#if osdkPackage}}
This project was generated with [\`@osdk/create-app\`](https://www.npmjs.com/package/@osdk/create-app) and demonstrates using the Ontology SDK package \`{{osdkPackage}}\` with Vue on top of Vite. Check out the [Vite](https://vitejs.dev/guide/) docs for further configuration.
{{else}}
This project was generated with [\`@osdk/create-app\`](https://www.npmjs.com/package/@osdk/create-app) and demonstrates using the Platform SDK with Vue on top of Vite. Check out the [Vite](https://vitejs.dev/guide/) docs for further configuration.

If you later add an Ontology SDK to your application, follow this [guide]({{foundryUrl}}/docs/foundry/ontology-sdk/add-osdk-to-bootstrapped-repository) to correctly set it up in this project.
{{/if}}

## Developing

Run the following command or equivalent with your preferred package manager to start a local development server on \`http://localhost:8080\`:

\`\`\`sh
npm run dev
\`\`\`

Development configuration is stored in \`.env.development\`.

{{#if corsProxy}}
In order to make API requests to Foundry, a CORS proxy has been set up for local development which may be removed if the stack is configured to allow \`http://localhost:8080\` to load resources. The configured OAuth client must also allow \`http://localhost:8080/auth/callback\` as a redirect URL.
{{else}}
In order to make API requests to Foundry, CORS must be configured for the stack to allow \`http://localhost:8080\` to load resources. If this has not been configured and you are unable to request this, you can alternatively generate your project again with \`--corsProxy true\` to use a proxy for API requests during local development. The configured OAuth client must also allow \`http://localhost:8080/auth/callback\` as a redirect URL.
{{/if}}

## Deploying

Run the following command or equivalent with your preferred package manager to create a production build of your application:

\`\`\`sh
npm run build
\`\`\`

Production configuration is stored in \`.env.production\`.

If you did not fill in the URL your production application will be hosted on you will need to fill in the \`VITE_FOUNDRY_REDIRECT_URL\` in \`.env.production\`. A default test is included in \`env.test.ts\` to verify your production environment variables which you can enable by removing the skip condition or running tests with the environment variable set \`VERIFY_ENV_PRODUCTION=true\`.

In order to make API requests to Foundry, CORS must be configured for the stack to allow the production origin to load resources. This will be automatically done for you if you are using Foundry website hosting. The configured OAuth client must also allow the production origin auth callback as a redirect URL.

A \`foundry.config.json\` file is included in the root of this project to make deploying to Foundry website hosting with [\`@osdk/cli\`](https://www.npmjs.com/package/@osdk/cli) easier. If you are not using Foundry website hosting for your application you may delete this file.
`
}], [".gitignore", {
  type: "raw",
  body: `# Logs
logs
*.log
npm-debug.log*
yarn-debug.log*
yarn-error.log*
pnpm-debug.log*
lerna-debug.log*

node_modules
dist
dist-ssr
*.local
.pnpm-store

# Editor directories and files
.vscode/*
!.vscode/extensions.json
.idea
.DS_Store
*.suo
*.ntvs*
*.njsproj
*.sln
*.sw?
`
}], ["index.html.hbs", {
  type: "raw",
  body: `<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <link rel="icon" type="image/svg+xml" href="/vue.svg" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="osdk-clientId" content="%VITE_FOUNDRY_CLIENT_ID%" />
    <meta name="osdk-redirectUrl" content="%VITE_FOUNDRY_REDIRECT_URL%" />
    <meta name="osdk-foundryUrl" content="%VITE_FOUNDRY_API_URL%" />
    {{#if osdkPackage}}
    <meta name="osdk-ontologyRid" content="%VITE_FOUNDRY_ONTOLOGY_RID%" />
    <title>Ontology SDK + Vue</title>
    {{else}}
    <title>Platform SDK + Vue</title>
    {{/if}}
  </head>
  <body>
    <div id="app-container">
      <div id="app"></div>
    </div>
    <script type="module" src="/src/main.ts"></script>
  </body>
</html>
`
}], ["package.json.osdk.hbs", {
  type: "raw",
  body: `{
  "name": "{{project}}",
  "private": true,
  "version": "0.0.0",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "vue-tsc && vite build",
    "test": "vitest run",
    "preview": "vite preview"
  },
  "dependencies": {
    "{{osdkPackage}}": "latest",
    "@osdk/client": "{{clientVersion}}",
    "@osdk/foundry": "^2.75.0",
    "@osdk/oauth": "^1.1.0",
    "vue": "^3.5.21",
    "vue-router": "^4.5.1"
  },
  "devDependencies": {
    "@types/node": "^24.12.0",
    "@vitejs/plugin-vue": "^5.2.4",
    "typescript": "~5.5.4",
    "vite": "^7.3.1",
    "vitest": "^3.2.4",
    "vue-tsc": "^2.2.12"
  }
}`
}], ["package.json.psdk.hbs", {
  type: "raw",
  body: `{
  "name": "{{project}}",
  "private": true,
  "version": "0.0.0",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "vue-tsc && vite build",
    "test": "vitest run",
    "preview": "vite preview"
  },
  "dependencies": {
    "@osdk/client": "{{clientVersion}}",
    "@osdk/foundry": "^2.75.0",
    "@osdk/oauth": "^1.1.0",
    "vue": "^3.5.21",
    "vue-router": "^4.5.1"
  },
  "devDependencies": {
    "@types/node": "^24.12.0",
    "@vitejs/plugin-vue": "^5.2.4",
    "typescript": "~5.5.4",
    "vite": "^7.3.1",
    "vitest": "^3.2.4",
    "vue-tsc": "^2.2.12"
  }
}`
}], ["public/book.svg", {
  "type": "base64",
  "body": "PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDFWMTVDMCAxNS41NSAwLjQ1IDE2IDEgMTZIMlYwSDFDMC40NSAwIDAgMC40NSAwIDFaTTExIDBIMTBWN0w4IDVMNiA3VjBIM1YxNkgxMUMxMS41NSAxNiAxMiAxNS41NSAxMiAxNVYxQzEyIDAuNDUgMTEuNTUgMCAxMSAwWiIgZmlsbD0iIzVGNkI3QyIvPgo8L3N2Zz4K"
}], ["public/cloud.svg", {
  "type": "base64",
  "body": "PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzNCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjM0IiBoZWlnaHQ9IjM0IiByeD0iMTciIGZpbGw9IiM4Rjk5QTgiIGZpbGwtb3BhY2l0eT0iMC4xNSIvPgo8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjMzIiBoZWlnaHQ9IjMzIiByeD0iMTYuNSIgc3Ryb2tlPSIjMTExNDE4IiBzdHJva2Utb3BhY2l0eT0iMC4xIi8+CjxwYXRoIGQ9Ik0yMSAxM0MyMC45NyAxMyAyMC45MyAxMyAyMC45IDEzLjAxQzIwLjQ0IDEwLjcyIDE4LjQyIDkgMTYgOUMxMy4yNCA5IDExIDExLjI0IDExIDE0QzExIDE0LjExIDExLjAxIDE0LjIyIDExLjAyIDE0LjMzQzkuODMgMTQuODkgOSAxNi4xIDkgMTcuNUM5IDE5LjQzIDEwLjU3IDIxIDEyLjUgMjFIMTVWMThDMTUgMTcuNDQ3NyAxNS40NDc3IDE3IDE2IDE3SDI0QzI0LjQzNjYgMTcgMjQuODA3OCAxNy4yNzk4IDI0Ljk0NDIgMTcuNjY5OUMyNC45ODA5IDE3LjQ1MjEgMjUgMTcuMjI4MyAyNSAxN0MyNSAxNC43OSAyMy4yMSAxMyAyMSAxM1oiIGZpbGw9IiM1RjZCN0MiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiAxOEgyNFYyMUgxNlYxOFpNMTkgMTkuNUMxOSAxOS4yMjM5IDE5LjIyMzkgMTkgMTkuNSAxOUgyMi41QzIyLjc3NjEgMTkgMjMgMTkuMjIzOSAyMyAxOS41QzIzIDE5Ljc3NjEgMjIuNzc2MSAyMCAyMi41IDIwSDE5LjVDMTkuMjIzOSAyMCAxOSAxOS43NzYxIDE5IDE5LjVaTTE4IDE5LjVDMTggMTkuNzc2MSAxNy43NzYxIDIwIDE3LjUgMjBDMTcuMjIzOSAyMCAxNyAxOS43NzYxIDE3IDE5LjVDMTcgMTkuMjIzOSAxNy4yMjM5IDE5IDE3LjUgMTlDMTcuNzc2MSAxOSAxOCAxOS4yMjM5IDE4IDE5LjVaIiBmaWxsPSIjNUY2QjdDIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTYgMjVWMjJIMjRWMjVIMTZaTTE5IDIzLjVDMTkgMjMuMjIzOSAxOS4yMjM5IDIzIDE5LjUgMjNIMjIuNUMyMi43NzYxIDIzIDIzIDIzLjIyMzkgMjMgMjMuNUMyMyAyMy43NzYxIDIyLjc3NjEgMjQgMjIuNSAyNEgxOS41QzE5LjIyMzkgMjQgMTkgMjMuNzc2MSAxOSAyMy41Wk0xNy41IDI0QzE3Ljc3NjEgMjQgMTggMjMuNzc2MSAxOCAyMy41QzE4IDIzLjIyMzkgMTcuNzc2MSAyMyAxNy41IDIzQzE3LjIyMzkgMjMgMTcgMjMuMjIzOSAxNyAyMy41QzE3IDIzLjc3NjEgMTcuMjIzOSAyNCAxNy41IDI0WiIgZmlsbD0iIzVGNkI3QyIvPgo8L3N2Zz4K"
}], ["public/cube.psdk.svg", {
  "type": "base64",
  "body": "PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzNCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjM0IiBoZWlnaHQ9IjM0IiByeD0iMTciIGZpbGw9IiM4Rjk5QTgiIGZpbGwtb3BhY2l0eT0iMC4xNSIvPgo8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjMzIiBoZWlnaHQ9IjMzIiByeD0iMTYuNSIgc3Ryb2tlPSIjMTExNDE4IiBzdHJva2Utb3BhY2l0eT0iMC4xIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjMuMTkzNyAxMi41Mzk0TDE3IDE2LjQxMDVMMTAuODA2MyAxMi41Mzk0TDE2LjUwMzkgOS4yODM2MUMxNi44MTEzIDkuMTA3OTQgMTcuMTg4NyA5LjEwNzk0IDE3LjQ5NjEgOS4yODM2MUwyMy4xOTM3IDEyLjUzOTRaTTIzLjk0MzggMTMuMjQ5OUMyMy45ODA1IDEzLjM1NDUgMjQgMTMuNDY2MSAyNCAxMy41ODA0VjIwLjQxOThDMjQgMjAuNzc4NiAyMy44MDc3IDIxLjExIDIzLjQ5NjEgMjEuMjg4TDE3LjUgMjQuNzE0NFYxNy4yNzcyTDIzLjk0MzggMTMuMjQ5OVpNMTAuMDU2MiAxMy4yNDk5TDE2LjUgMTcuMjc3MlYyNC43MTQ0TDEwLjUwMzkgMjEuMjg4QzEwLjE5MjMgMjEuMTEgMTAgMjAuNzc4NiAxMCAyMC40MTk4VjEzLjU4MDRDMTAgMTMuNDY2MSAxMC4wMTk1IDEzLjM1NDUgMTAuMDU2MiAxMy4yNDk5WiIgZmlsbD0iIzVGNkI3QyIvPgo8L3N2Zz4K"
}], ["public/palantir.svg", {
  "type": "base64",
  "body": "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjEwNzY4IDYuMDY0MDFDNC4xMDc2OCA4LjM3NzEgNS45NjcwMiAxMC4yNTI2IDguMjYwNTkgMTAuMjUyNkMxMC41NTQzIDEwLjI1MjYgMTIuNDEzOCA4LjM3NzEgMTIuNDEzOCA2LjA2NDAxQzEyLjQxMzggMy43NTA4IDEwLjU1NDMgMS44NzU1MyA4LjI2MDU5IDEuODc1NTNDNS45NjcwMiAxLjg3NTUzIDQuMTA3NjggMy43NTA4IDQuMTA3NjggNi4wNjQwMVpNOC4yNjA5MyAxMy45MjNMMTMuNjI5OSAxMS41ODQ4TDE0LjUyMTcgMTMuMzA5MUw4LjI2MDkzIDE2TDIgMTMuMzA5MUwyLjg5MjAxIDExLjU4NDhMOC4yNjA5MyAxMy45MjNaTTguMjYxMDEgMEM0Ljk0MzY3IDAgMi4yNTQ0MiAyLjcxMjI4IDIuMjU0NDIgNi4wNTgwM0MyLjI1NDQyIDkuNDAzNzggNC45NDM2NyAxMi4xMTU5IDguMjYxMDEgMTIuMTE1OUMxMS41NzgyIDEyLjExNTkgMTQuMjY3NiA5LjQwMzc4IDE0LjI2NzYgNi4wNTgwM0MxNC4yNjc2IDIuNzEyMjggMTEuNTc4MiAwIDguMjYxMDEgMFoiIGZpbGw9IiMxMTE0MTgiLz4KPC9zdmc+Cg=="
}], ["public/rocket.svg", {
  "type": "base64",
  "body": "PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzNCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjM0IiBoZWlnaHQ9IjM0IiByeD0iMTciIGZpbGw9IiM4Rjk5QTgiIGZpbGwtb3BhY2l0eT0iMC4xNSIvPgo8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjMzIiBoZWlnaHQ9IjMzIiByeD0iMTYuNSIgc3Ryb2tlPSIjMTExNDE4IiBzdHJva2Utb3BhY2l0eT0iMC4xIi8+CjxwYXRoIHRyYW5zZm9ybT0idHJhbnNsYXRlKDksIDkpIiBkPSJNMy45OTIgMTBjMi01IDUtOSAxMS05IDAgNi00IDktOSAxMXptNy43MTQtNC4yODVhMSAxIDAgMSAwLTEuNDE0LTEuNDE0IDEgMSAwIDAgMCAxLjQxNCAxLjQxNG0tNi41NTUtLjIxOGMtLjc0NSAxLjE0Mi0xLjM2OSAyLjM5Ny0xLjkxIDMuNjk4TC0uMDA5IDhsMy0yek03Ljk5MiAxNmwtMS4yMzYtMy4yMzJjMS4zLS41MzkgMi41NTItMS4xNTggMy42OTQtMS44OThMOS45OTIgMTN6bS00LjkzMS00Ljk0TDUgMTNjLS45OTIuOTkxLTIuMTg2IDEuMTU0LTMuMDAxIDEtLjE1NC0uODE1LjA3LTEuOTQ4IDEuMDYtMi45NCIgZmlsbD0iIzVGNkI3QyIvPgo8L3N2Zz4K"
}], ["public/vue.svg", {
  "type": "base64",
  "body": "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBhcmlhLWhpZGRlbj0idHJ1ZSIgcm9sZT0iaW1nIiBjbGFzcz0iaWNvbmlmeSBpY29uaWZ5LS1sb2dvcyIgd2lkdGg9IjM3LjA3IiBoZWlnaHQ9IjM2IiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCBtZWV0IiB2aWV3Qm94PSIwIDAgMjU2IDE5OCI+PHBhdGggZmlsbD0iIzQxQjg4MyIgZD0iTTIwNC44IDBIMjU2TDEyOCAyMjAuOEwwIDBoOTcuOTJMMTI4IDUxLjJMMTU3LjQ0IDBoNDcuMzZaIj48L3BhdGg+PHBhdGggZmlsbD0iIzQxQjg4MyIgZD0ibTAgMGwxMjggMjIwLjhMMjU2IDBoLTUxLjJMMTI4IDEzMi40OEw1MC41NiAwSDBaIj48L3BhdGg+PHBhdGggZmlsbD0iIzM1NDk1RSIgZD0iTTUwLjU2IDBMMTI4IDEzMy4xMkwyMDQuOCAwaC00Ny4zNkwxMjggNTEuMkw5Ny45MiAwSDUwLjU2WiI+PC9wYXRoPjwvc3ZnPg=="
}], ["src/AuthCallback.vue", {
  "type": "base64",
  "body": "PHNjcmlwdCBzZXR1cCBsYW5nPSJ0cyI+CmltcG9ydCB7IG9uTW91bnRlZCwgcmVmIH0gZnJvbSAidnVlIjsKaW1wb3J0IHsgYXV0aCB9IGZyb20gIi4vY2xpZW50IjsKaW1wb3J0IHsgdXNlUm91dGVyIH0gZnJvbSAidnVlLXJvdXRlciI7Cgpjb25zdCByb3V0ZXIgPSB1c2VSb3V0ZXIoKTsKCmNvbnN0IGVycm9yID0gcmVmPHN0cmluZz4oKTsKCm9uTW91bnRlZCgoKSA9PiB7CiAgYXV0aAogICAgLnNpZ25JbigpCiAgICAudGhlbigoKSA9PiByb3V0ZXIucmVwbGFjZSgiLyIpKQogICAgLmNhdGNoKChlOiB1bmtub3duKSA9PiB7CiAgICAgIGVycm9yLnZhbHVlID0gKGUgYXMgRXJyb3IpLm1lc3NhZ2U7CiAgICB9KTsKfSk7Cjwvc2NyaXB0PgoKPHRlbXBsYXRlPgogIDxkaXY+e3sgZXJyb3IgIT0gbnVsbCA\u002FIGVycm9yIDogIkF1dGhlbnRpY2F0aW5n4oCmIiB9fTwvZGl2Pgo8L3RlbXBsYXRlPgo="
}], ["src/Home.vue.hbs", {
  type: "raw",
  body: `<script setup lang="ts">
import Header from "./components/Header.vue";
import NextSteps from "./components/NextSteps.vue";
{{#if osdkPackage}}
import Osdk from "./components/Osdk.vue";
{{/if}}
</script>

<template>
  <div class="home">
    <Header />
    {{#if osdkPackage}}
    <Osdk />
    {{/if}}
    <NextSteps />
  </div>
</template>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  gap: 60px;
  max-width: 800px;
  width: 100%;
}
</style>
`
}], ["src/client.ts.hbs", {
  type: "raw",
  body: `{{#if osdkPackage}}
import { createClient, type Client } from "@osdk/client";
{{else}}
import { createPlatformClient, type PlatformClient } from "@osdk/client";
{{/if}}
import { createPublicOauthClient, type PublicOauthClient } from "@osdk/oauth";

function getMetaTagContent(tagName: string): string {
  const elements = document.querySelectorAll(\`meta[name="\${tagName}"]\`);
  const element = elements.item(elements.length - 1);
  const value = element ? element.getAttribute("content") : null;
  if (value == null || value === "") {
    throw new Error(\`Meta tag \${tagName} not found or empty\`);
  }
  if (value.match(/%.+%/)) {
    throw new Error(
      \`Meta tag \${tagName} contains placeholder value. Please add \${value.replace(
        /%/g,
        ""
      )} to your .env files\`
    );
  }
  return value;
}

const foundryUrl = getMetaTagContent("osdk-foundryUrl");
const clientId = getMetaTagContent("osdk-clientId");
const redirectUrl = getMetaTagContent("osdk-redirectUrl");
{{#if osdkPackage}}
const ontologyRid = getMetaTagContent("osdk-ontologyRid");
{{/if}}

{{#if scopes}}
const scopes = [
  {{#each scopes}}
  "{{this}}",
  {{/each}}
];
{{/if}}

export const auth: PublicOauthClient = createPublicOauthClient(
  clientId,
  foundryUrl,
  redirectUrl,
  {{#if scopes}}
  { scopes }
  {{/if}}
);

{{#if osdkPackage}}
/**
 * Initialize the client to interact with the Ontology and Platform SDKs
 */
export const client: Client = createClient(foundryUrl, ontologyRid, auth);
{{else}}
/**
 * Initialize the client to interact with the Platform SDK
 *
 * If you later add an Ontology SDK to your application, follow the steps in 
 * {{foundryUrl}}/docs/foundry/ontology-sdk/add-osdk-to-bootstrapped-repository/
 * to correctly set it up in this project.
 */
export const client: PlatformClient = createPlatformClient(foundryUrl, auth);
{{/if}}

export default client;
`
}], ["src/components/Header.vue", {
  "type": "base64",
  "body": "PHNjcmlwdCBzZXR1cCBsYW5nPSJ0cyI+PC9zY3JpcHQ+Cgo8dGVtcGxhdGU+CiAgPGhlYWRlciBjbGFzcz0iaGVhZGVyIj4KICAgIDxkaXYgY2xhc3M9ImxvZ29zIj4KICAgICAgPGEKICAgICAgICBocmVmPSJodHRwczovL3d3dy5wYWxhbnRpci5jb20vZG9jcy9mb3VuZHJ5L29udG9sb2d5LXNkay9vdmVydmlldy8iCiAgICAgICAgdGFyZ2V0PSJfYmxhbmsiCiAgICAgICAgcmVsPSJub3JlZmVycmVyIgogICAgICA+CiAgICAgICAgPGltZyBzcmM9Ii9wYWxhbnRpci5zdmciIGNsYXNzPSJsb2dvIiBhbHQ9IlBhbGFudGlyIGxvZ28iIC8+CiAgICAgIDwvYT4KICAgICAgPGEgaHJlZj0iaHR0cHM6Ly92dWVqcy5vcmcvIiB0YXJnZXQ9Il9ibGFuayIgcmVsPSJub3JlZmVycmVyIj4KICAgICAgICA8aW1nIHNyYz0iL3Z1ZS5zdmciIGNsYXNzPSJsb2dvIiBhbHQ9IlZ1ZSBsb2dvIiAvPgogICAgICA8L2E+CiAgICA8L2Rpdj4KICAgIDxoMiBjbGFzcz0iaGVhZGluZyI+QnVpbGQgeW91ciBWdWUgYXBwbGljYXRpb24gd2l0aCBGb3VuZHJ5ITwvaDI+CiAgPC9oZWFkZXI+CjwvdGVtcGxhdGU+Cgo8c3R5bGUgc2NvcGVkPgouaGVhZGVyIHsKICBhbGlnbi1pdGVtczogY2VudGVyOwogIGRpc3BsYXk6IGZsZXg7CiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjsKICBnYXA6IDQwcHg7Cn0KCi5sb2dvcyB7CiAgZGlzcGxheTogZmxleDsKICBnYXA6IDMycHg7Cn0KCi5sb2dvIHsKICBoZWlnaHQ6IDQ4cHg7CiAgdHJhbnNpdGlvbjogZmlsdGVyIDMwMG1zOwogIHdpbGwtY2hhbmdlOiBmaWx0ZXI7Cn0KCi5sb2dvOmhvdmVyIHsKICBmaWx0ZXI6IGRyb3Atc2hhZG93KDAgMCAyZW0gIzY0NmNmZmFhKTsKfQo8L3N0eWxlPgo="
}], ["src/components/NextSteps.vue.hbs", {
  type: "raw",
  body: `<script setup lang="ts">
interface INextStep {
  icon: string;
  title: string;
  subtitle: string;
}

const STEPS: INextStep[] = [
  {{^if osdkPackage}}
  {
    icon: "cube",
    title: "Configure your Ontology and Platform SDKs",
    subtitle:
      "Use the Ontology SDK to interact with your Ontology and the Platform SDK to access Foundry APIs. Configure your SDKs from the <strong>Ontology SDK</strong> and <strong>Platform SDK</strong> tabs in Developer Console.",
  },
  {{/if}}
  {{^if applicationUrl}}
  {
    icon: "cloud",
    title: "Request a subdomain to host your application with Foundry",
    subtitle:
      'Register a subdomain for your website on the <strong>Website hosting</strong> tab in Developer Console. Then, add this subdomain to your redirect URLs on the <strong>OAuth & scopes</strong> tab and update your <code class="code">.env.production</code> file.',
  },
  {{/if}}
  {
    icon: "rocket",
    title: "Deploy your application",
    subtitle:
      'To deploy a new version of your application, tag a new version of your repository or use the command line to run <code class="code">npx @osdk/cli@latest site deploy</code>. <a href="https://www.npmjs.com/package/@osdk/cli" class="learn-more" target="_blank" rel="noreferrer">Learn more.</a>',
  },
];
</script>

<template>
  <div class="next-steps">
    <h5 class="next-steps-header">Next steps</h5>
    <div v-for="step in STEPS" :key="step.title" class="next-step">
      <img :src="\`/\${step.icon}.svg\`" class="icon" alt="" />
      <div class="next-step-content">
        <h6 class="title">\\{{ step.title }}</h6>
        <div class="subtitle" v-html="step.subtitle" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.next-steps {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.next-steps-header {
  align-self: baseline;
  font-size: 16px;
  font-weight: 600;
}

.next-step {
  border: 1px solid #11141826;
  border-radius: 4px;
  display: flex;
  gap: 15px;
  padding: 16px;
}

.next-step-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
}

.icon {
  height: 34px;
}

.title {
  font-weight: 600;
}

.subtitle {
  color: #5f6b7c;
  line-height: 20px;
}

.subtitle :deep(.code) {
  background: #8f99a826;
  padding: 2px;
  white-space: nowrap;
  border-radius: 2px;
}

.subtitle :deep(.learn-more) {
  color: #215db0;
  text-decoration: none;
}

.subtitle :deep(.learn-more:hover) {
  text-decoration: underline;
}
</style>
`
}], ["src/components/Osdk.vue.osdk.hbs", {
  type: "raw",
  body: `<script setup lang="ts"></script>

<template>
  <div class="osdk">
    <div>
      <span>OSDK: </span>
      <span class="tag">{{osdkPackage}}</span>
    </div>
    <a
      href="{{foundryUrl}}/workspace/developer-console/app/{{application}}/docs/guide/loading-data?language=typescript"
      class="docs"
      target="_blank"
      rel="noreferrer"
    >
      <img src="/book.svg" width="16" height="16" alt="Book icon" />
      <span>View documentation</span>
    </a>
  </div>
</template>

<style scoped>
.osdk {
  align-self: baseline;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 800px;
}

.tag {
  border: 1px solid #11141826;
  border-radius: 2px;
  padding: 2px 4px;
}

.docs {
  align-items: center;
  border-radius: 2px;
  color: #1c2127;
  display: flex;
  gap: 8px;
  height: 30px;
  justify-content: center;
  padding: 0 5px;
  text-decoration: none;
}

.docs:hover {
  background: #8f99a826;
}
</style>
`
}], ["src/env.test.ts", {
  "type": "base64",
  "body": "aW1wb3J0IHsgbG9hZEVudiB9IGZyb20gInZpdGUiOwppbXBvcnQgeyBleHBlY3QsIHRlc3QgfSBmcm9tICJ2aXRlc3QiOwoKY29uc3QgRU5WX1ZBUlMgPSBbCiAgIlZJVEVfRk9VTkRSWV9BUElfVVJMIiwKICAiVklURV9GT1VORFJZX0NMSUVOVF9JRCIsCiAgIlZJVEVfRk9VTkRSWV9SRURJUkVDVF9VUkwiLApdOwoKZm9yIChjb25zdCBlbnZWYXIgb2YgRU5WX1ZBUlMpIHsKICB0ZXN0LnNraXBJZihwcm9jZXNzLmVudi5WRVJJRllfRU5WX1BST0RVQ1RJT04gIT09ICJ0cnVlIikoCiAgICBgcHJvZHVjdGlvbiBlbnYgc2hvdWxkIGNvbnRhaW4gJHtlbnZWYXJ9YCwKICAgICgpID0+IHsKICAgICAgY29uc3QgZW52ID0gbG9hZEVudigicHJvZHVjdGlvbiIsIHByb2Nlc3MuY3dkKCkpOwogICAgICBleHBlY3QoZW52W2VudlZhcl0sIGAke2VudlZhcn0gc2hvdWxkIGJlIGRlZmluZWRgKS50b0JlRGVmaW5lZCgpOwogICAgICBleHBlY3QoCiAgICAgICAgZW52W2VudlZhcl0sCiAgICAgICAgYCR7ZW52VmFyfSBzaG91bGQgbm90IGNvbnRhaW4gcGxhY2Vob2xkZXIgdmFsdWVgLAogICAgICApLm5vdC50b01hdGNoKC88Lio+Lyk7CiAgICB9LAogICk7Cn0K"
}], ["src/index.css", {
  "type": "base64",
  "body": "OnJvb3QgewogIGNvbG9yOiAjMWMyMTI3OwogIGZvbnQtZmFtaWx5OiAnU291cmNlIFNhbnMgUHJvJywgc3lzdGVtLXVpLCBBdmVuaXIsIEhlbHZldGljYSwgQXJpYWwsIHNhbnMtc2VyaWY7CiAgbGluZS1oZWlnaHQ6IDE4cHg7CiAgZm9udC1zaXplOiAxNHB4OwogIGZvbnQtc3ludGhlc2lzOiBub25lOwogIGZvbnQtd2VpZ2h0OiA0MDA7CiAgdGV4dC1yZW5kZXJpbmc6IG9wdGltaXplTGVnaWJpbGl0eTsKICAtd2Via2l0LWZvbnQtc21vb3RoaW5nOiBhbnRpYWxpYXNlZDsKICAtbW96LW9zeC1mb250LXNtb290aGluZzogZ3JheXNjYWxlOwp9CgojYXBwLWNvbnRhaW5lciB7CiAgYWxpZ24taXRlbXM6IGNlbnRlcjsKICBkaXNwbGF5OiBmbGV4OwogIGZsZXg6IDE7Cn0KCiNhcHAgewogIG1hcmdpbjogMCBhdXRvOwogIG1heC13aWR0aDogMTI4MHB4OwogIHBhZGRpbmc6IDJyZW07Cn0KCmJvZHkgewogIGRpc3BsYXk6IGZsZXg7CiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjsKICBtYXJnaW46IDA7CiAgbWluLWhlaWdodDogMTAwdmg7Cn0KCmgyIHsKICBmb250LXNpemU6IDI4cHg7CiAgbGluZS1oZWlnaHQ6IDMycHg7CiAgdGV4dC1hbGlnbjogY2VudGVyOwogIG1hcmdpbjogMDsKfQoKaDUsCmg2IHsKICBmb250LXNpemU6IDE0cHg7CiAgbWFyZ2luOiAwOwp9Cg=="
}], ["src/main.ts", {
  "type": "base64",
  "body": "aW1wb3J0IHsgY3JlYXRlQXBwIH0gZnJvbSAidnVlIjsKaW1wb3J0IHsgcm91dGVyIH0gZnJvbSAiLi9yb3V0ZXIiOwppbXBvcnQgIi4vaW5kZXguY3NzIjsKCmNvbnN0IGFwcCA9IGNyZWF0ZUFwcCh7CiAgdGVtcGxhdGU6ICI8cm91dGVyLXZpZXcgLz4iLAp9KTsKCmFwcC51c2Uocm91dGVyKS5tb3VudCgiI2FwcCIpOwo="
}], ["src/router.ts", {
  "type": "base64",
  "body": "aW1wb3J0IHsgY3JlYXRlUm91dGVyLCBjcmVhdGVXZWJIaXN0b3J5IH0gZnJvbSAidnVlLXJvdXRlciI7CmltcG9ydCBBdXRoQ2FsbGJhY2sgZnJvbSAiLi9BdXRoQ2FsbGJhY2sudnVlIjsKaW1wb3J0IEhvbWUgZnJvbSAiLi9Ib21lLnZ1ZSI7CgpleHBvcnQgY29uc3Qgcm91dGVyID0gY3JlYXRlUm91dGVyKHsKICBoaXN0b3J5OiBjcmVhdGVXZWJIaXN0b3J5KGltcG9ydC5tZXRhLmVudi5CQVNFX1VSTCksCiAgcm91dGVzOiBbCiAgICB7CiAgICAgIHBhdGg6ICIvIiwKICAgICAgY29tcG9uZW50OiBIb21lLAogICAgfSwKICAgIHsKICAgICAgLy8gVGhpcyBpcyB0aGUgcm91dGUgZGVmaW5lZCBpbiB5b3VyIGFwcGxpY2F0aW9uJ3MgcmVkaXJlY3QgVVJMCiAgICAgIHBhdGg6ICIvYXV0aC9jYWxsYmFjayIsCiAgICAgIGNvbXBvbmVudDogQXV0aENhbGxiYWNrLAogICAgfSwKICBdLAp9KTsK"
}], ["src/vite-env.d.ts", {
  "type": "base64",
  "body": "Ly8vIDxyZWZlcmVuY2UgdHlwZXM9InZpdGUvY2xpZW50IiAvPgo="
}], ["tsconfig.json", {
  "type": "base64",
  "body": "ewogICJjb21waWxlck9wdGlvbnMiOiB7CiAgICAidGFyZ2V0IjogIkVTMjAyMCIsCiAgICAidXNlRGVmaW5lRm9yQ2xhc3NGaWVsZHMiOiB0cnVlLAogICAgIm1vZHVsZSI6ICJFU05leHQiLAogICAgImxpYiI6IFsiRVMyMDIwIiwgIkRPTSIsICJET00uSXRlcmFibGUiXSwKICAgICJza2lwTGliQ2hlY2siOiB0cnVlLAoKICAgIC8qIEJ1bmRsZXIgbW9kZSAqLwogICAgIm1vZHVsZVJlc29sdXRpb24iOiAiYnVuZGxlciIsCiAgICAiYWxsb3dJbXBvcnRpbmdUc0V4dGVuc2lvbnMiOiB0cnVlLAogICAgInJlc29sdmVKc29uTW9kdWxlIjogdHJ1ZSwKICAgICJpc29sYXRlZE1vZHVsZXMiOiB0cnVlLAogICAgIm5vRW1pdCI6IHRydWUsCiAgICAianN4IjogInByZXNlcnZlIiwKCiAgICAvKiBMaW50aW5nICovCiAgICAic3RyaWN0IjogdHJ1ZSwKICAgICJub1VudXNlZExvY2FscyI6IHRydWUsCiAgICAibm9VbnVzZWRQYXJhbWV0ZXJzIjogdHJ1ZSwKICAgICJub0ZhbGx0aHJvdWdoQ2FzZXNJblN3aXRjaCI6IHRydWUKICB9LAogICJpbmNsdWRlIjogWyJzcmMvKiovKi50cyIsICJzcmMvKiovKi50c3giLCAic3JjLyoqLyoudnVlIl0sCiAgInJlZmVyZW5jZXMiOiBbeyAicGF0aCI6ICIuL3RzY29uZmlnLm5vZGUuanNvbiIgfV0KfQo="
}], ["tsconfig.node.json", {
  "type": "base64",
  "body": "ewogICJjb21waWxlck9wdGlvbnMiOiB7CiAgICAiY29tcG9zaXRlIjogdHJ1ZSwKICAgICJza2lwTGliQ2hlY2siOiB0cnVlLAogICAgIm1vZHVsZSI6ICJFU05leHQiLAogICAgIm1vZHVsZVJlc29sdXRpb24iOiAiYnVuZGxlciIsCiAgICAiYWxsb3dTeW50aGV0aWNEZWZhdWx0SW1wb3J0cyI6IHRydWUKICB9LAogICJpbmNsdWRlIjogWyJ2aXRlLmNvbmZpZy50cyJdCn0K"
}], ["vite.config.ts.hbs", {
  type: "raw",
  body: `{{#if osdkPackage}}
{{#if unstableFeatures}}
import { branchPlugin } from "@osdk/vite-plugin-branch";
{{/if}}
{{/if}}
import vue from "@vitejs/plugin-vue";
import { defineConfig } from "vite";

// https://vitejs.dev/config/
export default defineConfig(({ mode }) => {  
  return {
    plugins: [vue(){{#if osdkPackage}}{{#if unstableFeatures}}, branchPlugin(){{/if}}{{/if}}],
    server: {
      port: 8080,
      {{#if corsProxy}}
      proxy: {
        "^(/multipass/api|/api)": {
          target: "{{foundryUrl}}",
          changeOrigin: true,
          secure: true,
        },
      },
      {{/if}}
    },
    resolve: {
      alias: {
        vue: "vue/dist/vue.esm-bundler",
      },
    },
    define: {
      "process.env.NODE_ENV": JSON.stringify(mode),
    },
  };
});
`
}]]);